import dJSON from 'dirty-json';
import Splide from '@splidejs/splide';
import preprocessJson from '../../../js/utils/preprocess-json';

const moduleSelector = '.hero-section-1 .splide';

/**
 * Module Init
 */
(() => {
  const modules = document.querySelectorAll(moduleSelector);
  if (!modules.length) return;

  modules.forEach((query) => {
    const sliderList = query.querySelector('.splide__list');
    try {
      sliderList.querySelector('script')?.remove(); // cleanup

      const { data } = dJSON.parse(preprocessJson(sliderList.data));

      data.forEach((item) => {
        const {
          background, smallTitle, title, text, buttonText, buttonLink,
        } = item;
        const slide = document.createElement('div');
        slide.className = 'splide__slide';
        slide.innerHTML = /* html */ `
          <div class="hero-section__slide hero-section__element">
            <div class="image-wrapper">
              <img src="${background}" alt="" aria-hidden="true" role="presentation">
            </div>
            <div class="container">
              <div class="hero-section__element__content">
                ${smallTitle && smallTitle.trim() ? `<h2 class="hero-section__element__kicker">${smallTitle}</h2>` : ''}
                ${title && title.trim() ? `<h3 class="hero-section__element__title">${title}</h3>` : ''}
                ${text && text.trim() ? `<p class="hero-section__element__description">${text}</p>` : ''}
                ${buttonText && buttonText.trim() && buttonLink && buttonLink.trim() ? `<a class="btn-custom primary" href="${buttonLink}">${buttonText}</a>` : ''}
              </div>
            </div>
          </div>
        `;
        sliderList.appendChild(slide);
      });

      const slider = new Splide(query, {
        type: 'loop',
        perPage: 1,
        perMove: 1,
        pagination: true,
        arrows: false,
        autoplay: false,
        height: 683,
      });
      slider.mount();
    } catch (error) {
      console.error(`Error: ${moduleSelector}`, error);
    }
  });
})();
